"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CodeRenderer = CodeRenderer;

var _react = _interopRequireDefault(require("react"));

var _prismReactRenderer = _interopRequireWildcard(require("prism-react-renderer"));

var _duotoneLight = _interopRequireDefault(require("prism-react-renderer/themes/duotoneLight"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CodeRenderer(_ref) {
  var _ref$code = _ref.code,
      code = _ref$code === void 0 ? '' : _ref$code,
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? 'jsx' : _ref$language,
      _ref$removeIndentatio = _ref.removeIndentation,
      removeIndentation = _ref$removeIndentatio === void 0 ? false : _ref$removeIndentatio;

  if (removeIndentation) {
    code = unindent(code);
  }

  return /*#__PURE__*/_react.default.createElement(_prismReactRenderer.default, _extends({}, _prismReactRenderer.defaultProps, {
    code: code,
    language: language,
    theme: _duotoneLight.default
  }), function (_ref2) {
    var className = _ref2.className,
        style = _ref2.style,
        tokens = _ref2.tokens,
        getLineProps = _ref2.getLineProps,
        getTokenProps = _ref2.getTokenProps;
    return /*#__PURE__*/_react.default.createElement("pre", {
      className: className,
      style: style
    }, tokens.map(function (line, i) {
      return /*#__PURE__*/_react.default.createElement("div", getLineProps({
        line: line,
        key: i
      }), line.map(function (token, key) {
        return /*#__PURE__*/_react.default.createElement("span", getTokenProps({
          token: token,
          key: key
        }));
      }));
    }));
  });
}

function unindent(code) {
  // remove leading empty line, and trailing whitespace and split lines
  var lines = code.replace(/^\s*\n/, '').trimRight().split('\n'); // determine smallest left indent for all lines

  var leftIndent = lines.filter(function (line) {
    return !/^\s*$/.test(line);
  }) // ignore empty lines
  .reduce(function (smallestIndent, line) {
    return Math.min(smallestIndent, line.match(/[^\s]/).index);
  }, // index of first non-space character
  Number.MAX_SAFE_INTEGER // default indentation value
  ); // join lines, removing left indentation

  return lines.map(function (line) {
    return line.slice(leftIndent);
  }).join('\n');
}